// import Pdf from '../../../../media/images/pdf-img.svg'
import { useState } from 'react'
import Download from '../../../../media/images/download.svg'
import { downloadFileSigned } from '../../investor-crm/core/_requests'
import '../style/attachments.scss'
import { Spinner } from 'react-bootstrap'

export default function Attachments({ image, attachmentName, fileName }: any) {
  const [isDownloading, setIsDownloading] = useState<boolean>(false)

  const onDownloadFile = async (fileName: string) => {
    setIsDownloading(true)
    const key = encodeURIComponent(fileName)
    console.log(key, ' key')
    try {
      const {
        data: { data: signedUrl, success },
      } = await downloadFileSigned(key)
      if (success) {
        console.log(signedUrl)
        const a = document.createElement('a')
        a.href = signedUrl
        a.download = 'download'
        document.body.appendChild(a)
        a.click()
        a.remove()
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsDownloading(false)
    }
  }

  return (
    <>
      <div className='attachment-container bg-light'>
        <img src={image} alt='pdf-icon' />
        <div className='d-flex justify-content-between align-items-center attachment-name'>
          <h3>{attachmentName.length > 20 ? attachmentName.slice(0, 22) + `...` : attachmentName}</h3>
          <div onClick={() => onDownloadFile(fileName)}>
            {isDownloading ? (
              <Spinner animation={'border'} />
            ) : (
              <img className='cursor-pointer inbox-prev-next-logo' src={Download} alt='doc-icon' />
            )}
          </div>
        </div>
      </div>
    </>
  )
}
